import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const testimonials = [
  {
    quote: 'Prakash turned my idea into a clean, responsive website with a premium feel. The design was sharp and the mobile version looked great.',
    name: 'Aisha Khan',
    role: 'Freelance Photographer',
    img: '/img/testimonial-1.jpg',
    accent: 'var(--aqua)',
  },
  {
    quote: 'He understood the layout quickly, improved the visual details, and delivered a smooth website that matched the brand much better.',
    name: 'Rahul Sharma',
    role: 'Small Business Owner',
    img: '/img/testimonial-2.jpg',
    accent: 'var(--rose)',
  },
  {
    quote: 'The site felt fast, colorful, and professional. Prakash was easy to work with and handled changes without confusion.',
    name: 'Michael Lee',
    role: 'E-commerce Owner',
    img: '/img/testimonial-3.jpg',
    accent: 'var(--sun)',
  },
];

export default function Testimonials() {
  const [current, setCurrent] = useState(0);
  const [ref, inView] = useInView({ threshold: 0.1, triggerOnce: true });

  const prev = () => setCurrent(index => (index - 1 + testimonials.length) % testimonials.length);
  const next = () => setCurrent(index => (index + 1) % testimonials.length);
  const testimonial = testimonials[current];

  return (
    <section id="testimonial" ref={ref} className="section-pad alt">
      <div className="ghost-text">REVIEWS</div>

      <div className="section-shell" style={{ maxWidth: 960 }}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
          style={{ textAlign: 'center', marginBottom: 48 }}
        >
          <div className="eyebrow" style={{ justifyContent: 'center' }}>Client feedback</div>
          <h2 className="section-title">People notice the polish.</h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 28 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.18 }}
          className="premium-card"
          style={{ padding: 'clamp(26px, 5vw, 52px)', textAlign: 'center' }}
        >
          <AnimatePresence mode="wait">
            <motion.div
              key={current}
              initial={{ opacity: 0, y: 18 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -18 }}
              transition={{ duration: 0.32 }}
            >
              <div className="color-line" style={{ margin: '0 auto 30px', background: `linear-gradient(90deg, ${testimonial.accent}, var(--sun))` }} />
              <p style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(1.25rem, 3vw, 2rem)', lineHeight: 1.45, color: 'var(--white)', marginBottom: 34 }}>
                "{testimonial.quote}"
              </p>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 14 }}>
                <img
                  src={testimonial.img}
                  alt={`${testimonial.name} testimonial for Prakash C web development services`}
                  loading="lazy"
                  decoding="async"
                  style={{ width: 62, height: 62, borderRadius: 8, objectFit: 'cover', border: `2px solid ${testimonial.accent}` }}
                  onError={event => { event.currentTarget.src = '/img/profile.jpg'; }}
                />
                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontFamily: 'var(--font-display)', fontWeight: 800 }}>{testimonial.name}</div>
                  <div style={{ color: testimonial.accent, fontSize: 12, fontWeight: 700 }}>{testimonial.role}</div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 16, marginTop: 38 }}>
            <button onClick={prev} className="btn-secondary" style={{ minWidth: 48, width: 48, padding: 0 }} aria-label="Previous testimonial">&lt;</button>
            <div style={{ display: 'flex', gap: 8 }}>
              {testimonials.map((item, index) => (
                <button
                  key={item.name}
                  onClick={() => setCurrent(index)}
                  aria-label={`Show testimonial ${index + 1}`}
                  style={{
                    width: index === current ? 26 : 9,
                    height: 9,
                    border: 'none',
                    borderRadius: 8,
                    cursor: 'pointer',
                    background: index === current ? testimonial.accent : 'rgba(255,255,255,0.2)',
                    transition: 'all 0.25s ease',
                  }}
                />
              ))}
            </div>
            <button onClick={next} className="btn-secondary" style={{ minWidth: 48, width: 48, padding: 0 }} aria-label="Next testimonial">&gt;</button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
